import React from 'react';
import styles from './styles.module.scss';
import {CircleUserRound, UserRoundPen} from 'lucide-react';
import classNames from 'classnames';
import {APP_PATHS} from '../../../../constants';
import {Link} from 'react-router-dom';
import useIsMobile from '../../../../hooks/useIsMobile';

const Auth: React.FC = () => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.wrapper}>
      <Link to={APP_PATHS.LOGIN}>
        <div className={classNames(styles.dark, styles.btn)}>
          {!isMobile && (
            <div>
              <CircleUserRound stroke="currentColor" strokeWidth={1.5} />
            </div>
          )}
          Sign In
        </div>
      </Link>
      <Link to={APP_PATHS.SIGN_UP}>
        <div className={classNames(styles.green, styles.btn)}>
          {!isMobile && (
            <div>
              <UserRoundPen stroke="currentColor" strokeWidth={1.5} />
            </div>
          )}
          Sign Up
        </div>
      </Link>
    </div>
  );
};

export default Auth;
